import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import ChatWidget from "@/components/ChatWidget";

export default function PreviewPage() {
  const { user } = useAuth();
  const [sector, setSector] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.sector_id) { setLoading(false); return; }
    api.get(`/sectors/${user.sector_id}`).then(({ data }) => setSector(data)).finally(() => setLoading(false));
  }, [user]);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;
  if (!sector) return <p className="text-slate-500">Sem setor atribuído.</p>;

  return (
    <div>
      <PageHeader title="Preview do chatbot" subtitle={`Simule uma conversa com o chatbot do setor "${sector.name}" antes de publicar.`} />
      <Card className="p-8 relative min-h-[600px] bg-gradient-to-br from-slate-50 to-slate-100 border-slate-200 overflow-hidden">
        <div className="max-w-md">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-3">Simulação de site</p>
          <h2 className="font-[Outfit] text-2xl font-semibold text-slate-800 mb-3">
            Instituto Federal do Paraná
          </h2>
          <p className="text-sm text-slate-600 leading-relaxed">
            Esta é uma prévia de como o widget do chatbot do setor <b>{sector.name}</b> aparece
            para os visitantes do site institucional. Clique na bolha no canto inferior direito
            para conversar.
          </p>
        </div>
        <ChatWidget slug={sector.slug} previewMode />
      </Card>
    </div>
  );
}
